// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1xCxs","consentsList":"PatientConsents_consentsList__2fT9G","consentsListEmpty":"PatientConsents_consentsListEmpty__1cBdl"};